import { render, staticRenderFns } from "./editPurchaseApplyList.vue?vue&type=template&id=12b14002&scoped=true"
import script from "./editPurchaseApplyList.vue?vue&type=script&lang=js"
export * from "./editPurchaseApplyList.vue?vue&type=script&lang=js"
import style0 from "./editPurchaseApplyList.vue?vue&type=style&index=0&id=12b14002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b14002",
  null
  
)

export default component.exports